import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import moment from 'moment'
import ChartLine from '../../../components/charts/ChartLine'
import { ChartLineThemes } from '../../../components/charts/types/ChartLine'
import ChartLineSkeleton from '../../../components/skeletons/ChartLineSkeleton'
import { EventsFiltersContext } from '../../../context/EventsFiltersContext'
import { FilterEvents } from '../../../types/FilterEvents'
import { formatDateCard, formatNumber } from '../../../utils/Helpers'
import { GET_QUANTITY_OFFERS_ERRORS_PER_DAY } from '../../../queries/events'
import { defaultDateRange, defaultFormatTimeZone } from '../../../utils/consts'

type Series = {
  name: string
  data: number[]
}

type BucketTypes = {
  key_as_string: string
  key: number
  doc_count: number
}

const DailyOffersErrors = (): JSX.Element => {
  const { filters } = useContext(EventsFiltersContext)
  const categories: Array<string> = []
  const series: Array<Series> = []
  series.push({ name: 'Erros', data: [] })

  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_QUANTITY_OFFERS_ERRORS_PER_DAY, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    let date: FilterEvents['date'] = { ...defaultDateRange }

    if (filters.date) {
      date = {
        ...filters.date,
        ...defaultFormatTimeZone
      }
    }
    getData({
      variables: { filters: { ...filters, date } }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartLineSkeleton />
  if (loading || !data) return <ChartLineSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.eventOfferIntegrationValidatorErrorAggs.aggregations) return <p>No data found</p>

  const { buckets } = data.eventOfferIntegrationValidatorErrorAggs.aggregations.errorsOverTime
  buckets.map((bucket: BucketTypes) => {
    series[0].data.push(bucket.doc_count)
  })

  buckets.map((bucket: BucketTypes) => {
    categories.push(bucket.key_as_string)
  })

  const options = {
    chart: {
      id: 'daily-offers-errors'
    },
    xaxis: {
      categories,
      type: 'datetime',
      labels: {
        formatter: (value: Date) => {
          return moment(value).format('DD-MM-YYYY')
        }
      }
    },
    yaxis: {
      categories,
      labels: {
        formatter: (value: number) => {
          return formatNumber(value)
        }
      }
    },
    tooltip: {
      y: {
        formatter: (value: number) => {
          return formatNumber(value, 0)
        }
      }
    }
  }

  return <Paper elevation={2}>
    <Typography paragraph style={{ paddingLeft: '20px', paddingTop: '20px' }}>Ofertas com erros ({formatDateCard(filters.date?.initialDate, filters.date?.finalDate)})</Typography>
    <ChartLine options={options} series={series} theme={ChartLineThemes.red} height={320} type="area"/>
  </Paper>
}

export default DailyOffersErrors
